import { SubmissionError } from 'redux-form'

const MIN_SNAP_AGE = 16
const MAX_AGE = 125

export default (values) => {
  const errors = {}

  if (!values.firstName) {
    errors.firstName = 'First name required'
  }
  if (!values.lastName) {
    errors.lastName = 'Last name required'
  }
  if (!values.realEmail) {
    errors.realEmail = 'Email required'
  }
  if (
    values.realEmail &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.realEmail)
  ) {
    errors.realEmail = 'Invalid email address'
  }
  if (!values.password) {
    errors.password = 'Password required'
  } else if (values.password.length < 8) {
    errors.password = 'Password must be at least 8 characters'
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = 'Password confirmation required'
  }
  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Passwords do not match'
  }
  if (!values.gender) {
    errors.gender = 'Gender is required'
  }
  if (!values.units) {
    errors.units = 'Unit type required'
  }
  if (!values.age && values.age !== 0) {
    errors.age = 'Age is required'
  } else {
    const age = Number(values.age)
    if (isNaN(age) || !Number.isInteger(age)) {
      errors.age = 'Age must be a whole number'
    } else if (age < MIN_SNAP_AGE) {
      errors.age = `Must be at least ${MIN_SNAP_AGE} years old`
    } else if (age >= MAX_AGE) {
      errors.age = 'Please enter a valid age'
    }
  }
  if (!values.termsAccepted) {
    errors.termsAccepted = '- Please accept the Terms Agreement to continue'
  }
  if (!values.privacyPolicyAccepted) {
    errors.privacyPolicyAccepted =
      "- Please accept Fit3D's privacy policy to continue"
  }
  if (!values.turnstileToken) {
    errors.turnstileToken = 'Please complete the security check'
  }

  if (Object.keys(errors).length > 0) {
    throw new SubmissionError(Object.assign({}, errors, { _error: errors }))
  }
}
